import { accommodationSubTypeZodObject } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-sub-type";
import { accommodationTypeIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-type-id";
import { capacityZodObject } from "@@/shared/acquire/resources/resource-accommodation/capacity";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { iconNameZodString } from "@@/shared/icon-name";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const accommodationTypeEditCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("ACCOMMODATION_TYPE_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    accommodationTypeId: accommodationTypeIdZodSchema,
    title: requiredTranslatableZodSchema,
    iconName: iconNameZodString.optional(),
    shortDescription: translatableZodSchema.optional(),
    providerId: providerIdZodSchema.optional(),
    subTypes: z.array(accommodationSubTypeZodObject).optional(),
    capacity: capacityZodObject,
});

type AccommodationTypeEditCommand = z.infer<
    typeof accommodationTypeEditCommandZodObject
>;

const accommodationTypeEditCommandFactoryParamsZodObject =
    accommodationTypeEditCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof accommodationTypeEditCommandFactoryParamsZodObject
>;

const accommodationTypeEditCommandFactory = (params: FactoryParams) => {
    const accommodationTypeEditCommand: AccommodationTypeEditCommand = {
        ...params,
        _id: generateId({ prefix: "accommodation_type_edit_command__" }),
        _type: "ACCOMMODATION_TYPE_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return accommodationTypeEditCommand;
};

export {
    accommodationTypeEditCommandFactory,
    accommodationTypeEditCommandFactoryParamsZodObject,
    accommodationTypeEditCommandZodObject,
};
export type {
    AccommodationTypeEditCommand,
    FactoryParams as AccommodationTypeEditCommandFactoryParams,
};
